import { ArrowRight, X } from "lucide-react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const announcements = [
  {
    id: 1,
    icon: "🎨",
    text: "NOUVEAU : Ad Creative Studio - Créez des publicités pro en 1 clic !",
    link: "/ad-studio",
    cta: "Essayer",
  },
  {
    id: 2,
    icon: "⚡",
    text: "Floop Pro - Qualité studio professionnelle avec notre IA avancée",
    link: "/create",
    cta: "Découvrir",
  },
  {
    id: 3,
    icon: "🎁",
    text: "10 crédits offerts à l'inscription - Aucune carte requise !",
    link: "/auth",
    cta: "S'inscrire",
  },
];

// Export the state hook for Header to consume
let setAnnouncementVisible: ((visible: boolean) => void) | null = null;
let isAnnouncementBarVisible = true;

export function getAnnouncementBarHeight() {
  return isAnnouncementBarVisible ? 44 : 0;
}

export function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setAnnouncementVisible = setIsVisible;
    isAnnouncementBarVisible = isVisible;
    
    // Dispatch custom event when visibility changes
    window.dispatchEvent(new CustomEvent('announcementBarChange', { detail: { visible: isVisible } }));
    
    return () => {
      setAnnouncementVisible = null;
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-primary via-accent to-primary bg-[length:200%_100%] animate-gradient-x text-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="relative flex items-center justify-center py-2.5 min-h-[44px]">
          {/* Scrolling content */}
          <div className="flex items-center gap-2 animate-marquee whitespace-nowrap">
            {[...announcements, ...announcements].map((announcement, index) => (
              <Link
                key={`${announcement.id}-${index}`}
                to={announcement.link}
                className="inline-flex items-center gap-2 px-6 hover:opacity-90 transition-opacity group"
              >
                <span className="text-lg">{announcement.icon}</span>
                <span className="text-sm font-medium">{announcement.text}</span>
                <span className="inline-flex items-center gap-1 text-xs font-bold bg-white/20 px-2 py-0.5 rounded-full group-hover:bg-white/30 transition-colors">
                  {announcement.cta}
                  <ArrowRight className="w-3 h-3" />
                </span>
                <span className="mx-4 text-white/40">•</span>
              </Link>
            ))}
          </div>

          {/* Close button */}
          <button
            onClick={() => setIsVisible(false)}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Fermer l'annonce"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}